<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-md-6 col-xl-4">
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-warning`"
            slot="header"
          >
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Daily</p>
            {{ number.daily }}
          </div>
          <div class="stats" slot="footer">
            <i class="ti-calendar"></i> Stockout
          </div>
        </stats-card>
      </div>

      <div class="col-md-6 col-xl-4">
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-primary`"
            slot="header"
          >
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Weekly</p>
            {{ number.week }}
          </div>
          <div class="stats" slot="footer">
            <i class="ti-calendar"></i> Stockout
          </div>
        </stats-card>
      </div>

      <div class="col-md-6 col-xl-4">
        <stats-card>
          <div class="icon-big text-center" :class="`icon-info`" slot="header">
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Monthly</p>
            {{ number.month }}
          </div>
          <div class="stats" slot="footer">
            <i class="ti-calendar"></i> Stockout
          </div>
        </stats-card>
      </div>
    </div>

    <!-- CHARTS -->

    <div class="row">
      <div class="col md-12">
        <b-card>
          <Bar
            :label="label[selectedGType - 1]"
            :data_graph="data_graph[selectedGType - 1]"
            v-if="isLoading === false"
          />
          <span slot="footer">
            <b-col sm="2">
              <b-form-select
                v-model="selectedGType"
                :options="graphType"
                class="input-new"
                @change="changeType"
              ></b-form-select>
            </b-col>
          </span>
        </b-card>
      </div>
    </div>

    <!-- STATS CARD -->

    <div class="row">
      <div
        class="col-md-4 col-xl-4"
        v-for="stats in statsCards"
        :key="stats.title"
        @click="onClick(stats.route)"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-${stats.type}`"
            slot="header"
          >
            <i :class="stats.icon"></i>
            <!-- <img src="src/styles/assets/icons/product/milk.svg" alt="Milk" width="460" height="345" /> -->
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
        </stats-card>
      </div>
    </div>

    <b-card>
      <h5><b> LIST OF NOTIFICATIONS</b></h5>
      <hr />
      <b-table
        show-empty
        head-variant="dark"
        striped
        hover
        bordered
        :items="items"
        :fields="fields"
        id="my-table"
        :per-page="perPage"
        :current-page="currentPage"
      >
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card>

    <first-time-modal @close="onFTModal($event)" />
  </div>
</template>
<script>
// import { StatsCard } from "@/components/index";
import { StatsCard } from "@/components/index";
// import Chartist from "chartist";
// CommitChart.js
import Bar from "@/components/Chart/Bar";
import { FirstTimeModal } from "@/components/index";
import moment from "moment";

export default {
  components: {
    StatsCard,
    Bar,
    FirstTimeModal
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      statsCards: [
        {
          type: "warning",
          icon: "ti-package",
          title: "Stockout",
          route: "/stockout"
        },
        {
          type: "success",
          icon: "ti-credit-card",
          title: "Purchase Order",
          route: "/purchase_order"
        },
        {
          type: "danger",
          icon: "ti-export",
          title: "Delivery Order",
          route: "/delivery_order"
        },
        {
          type: "info",
          icon: "ti-menu",
          title: "Monthly Forecast",
          route: "/monthly_forecast"
        },
        {
          type: "success",
          icon: "ti-user",
          title: "User Management",
          route: "/user_management"
        },
        {
          type: "danger",
          icon: "ti-home",
          title: "Outlet",
          route: "/outlet"
        },
        {
          type: "info",
          icon: "ti-package",
          title: "Product",
          route: "product"
        },
        {
          type: "info",
          icon: "ti-harddrives",
          title: "Audit Trail",
          route: "audit_trail"
        }
      ],

      isLoading: true,

      // name
      name: "",
      firstTime: false,

      number: {
        daily: "",
        week: "",
        month: ""
      },

      graphType: [
        { value: 1, text: "Daily" },
        { value: 2, text: "Weekly" },
        { value: 3, text: "Monthly" }
      ],

      selectedGType: 1,

      label: [],

      data_graph: [],

      items: [],

      fields: [
        {
          label: "Notifications",
          key: "mesej",
          sortable: false
        }
      ],

      perPage: 10,
      currentPage: 1,
      filter: null,
      filterOn: [],
      totalRows: 1
    };
  },

  created() {
    this.getUserData();
    this.getNotiUser();
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    rows() {
      return this.items.length;
    }
  },

  mounted() {
    this.getGraph();
    // Set the initial number of items
    this.totalRows = this.items.length;
  },

  methods: {
    onClick(path) {
      this.$router.push({ path: path });
    },

    getUserData() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$store.getters.getUser_id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.name = res.data.data.name;
            this.firstTime = res.data.data.first_password;
          }
          // this.showFirstTime();
        });
    },

    getNotiUser() {
      this.$store.dispatch("getNotiUser").then(res => {
        if (res.data.response.code === 100) {
          this.items = [];

          res.data.data.forEach(element => {
            this.items.push({
              mesej:
                element.message + " - " + element.date + " - " + element.time,
              date: element.date,
              time: element.time
            });
          });
        }
      });
    },

    changeType() {
      this.isLoading = true;
      this.getGraph();
    },

    async test() {
      this.isLoading = await false;
    },

    getGraph() {
      this.$store.dispatch("getGraph").then(res => {
        if (res.data.response.code === 100) {
          let data1 = [];
          let label1 = [];
          let data2 = [];
          let label2 = [];
          let data3 = [];
          let label3 = [];
          res.data.data.daily.forEach(item => {
            label1.push(moment(item.no_day).format("DD/MM/YYYY"));
            data1.push(item.no_stock);
          });
          res.data.data.week.forEach(item => {
            label2.push(item.no_week);
            data2.push(item.no_stock);
          });
          res.data.data.month.forEach(item => {
            label3.push(item.no_month);
            data3.push(item.no_stock);
          });

          this.label.push(label1, label2, label3);
          this.data_graph.push(data1, data2, data3);
          this.isLoading = false;

          this.getDashboard();
        }
      });
    },

    getDashboard() {
      this.$store.dispatch("getNumber").then(res => {
        if (res.data.response.code === 100) {
          this.number.daily = res.data.data.daily;
          this.number.week = res.data.data.week;
          this.number.month = res.data.data.month;
        }
      });
    },

    // Show Modal
    showFirstTime() {
      if (this.firstTime === true) {
        this.$bvModal.show("first-time");
      }
    },

    onFTModal(response) {
      if (response === "success") {
        this.$bvModal.hide("first-time");
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
<style></style>
